export interface Spell {
  id: string;
  name: string;
  level: number; // 0 for cantrips, 1-9 for leveled spells
  school: string;
  castingTime: string;
  range: string;
  components: string;
  material?: string;
  duration: string;
  concentration: boolean;
  ritual: boolean;
  description: string;
  classes: string[];
  tags: string[];
  source: string;
  srd: boolean;
}

export interface Item {
  id: string;
  name: string;
  type: string;
  rarity: string;
  attunement: boolean;
  description: string;
  weight?: string;
  damage?: string;
  ac?: string;
  range?: string;
  weaponMastery?: string;
  charges?: number;
  srd?: boolean;
  source?: string;
}

export interface ClassFeature {
  id: string;
  name: string;
  className: string;
  subclass?: string;
  featureType?: 'invocation'; // Eldritch Invocations are class features with special display
  level: number;
  description: string;
  source: string;
}

export type SpellClass =
  | 'Artificer'
  | 'Bard'
  | 'Cleric'
  | 'Druid'
  | 'Paladin'
  | 'Ranger'
  | 'Sorcerer'
  | 'Warlock'
  | 'Wizard';

export const SPELL_CLASSES: SpellClass[] = [
  'Artificer',
  'Bard',
  'Cleric',
  'Druid',
  'Paladin',
  'Ranger',
  'Sorcerer',
  'Warlock',
  'Wizard',
];

// Item rarities for filtering
export const ITEM_RARITIES = [
  'Common',
  'Uncommon',
  'Rare',
  'Very Rare',
  'Legendary',
  'Artifact',
] as const;

export type ItemRarity = typeof ITEM_RARITIES[number];

// D&D Classes for class features
export const DND_CLASSES = [
  'Barbarian',
  'Bard',
  'Cleric',
  'Druid',
  'Fighter',
  'Monk',
  'Paladin',
  'Ranger',
  'Rogue',
  'Sorcerer',
  'Warlock',
  'Wizard',
] as const;

export type DndClass = typeof DND_CLASSES[number];

// Card back settings
export const CARD_BACK_LOGOS = [
  'd20',
  'crossed-swords',
  'dragon',
  'spellbook',
  'wizard-tower',
  'crystal-ball',
  'potion-bottle',
  'shield-crest',
  'arcane-runes',
  'skull-bones',
] as const;

export type CardBackLogoType = typeof CARD_BACK_LOGOS[number];

export type FeatCategory =
  | 'Origin'
  | 'General'
  | 'Fighting Style'
  | 'Epic Boon'
  | 'Dragonmark'
  | 'Greater Dragonmark';

export const FEAT_CATEGORIES: FeatCategory[] = [
  'Origin',
  'General',
  'Fighting Style',
  'Epic Boon',
  'Dragonmark',
  'Greater Dragonmark',
];

export interface Feat {
  id: string;
  name: string;
  category: FeatCategory;
  prerequisite?: string;
  description: string;
  source: string;
}

export type CardBackStyle = 'solid' | 'white';

export interface CardBackSettings {
  enabled: boolean;
  logoType: CardBackLogoType;
  style: CardBackStyle;
}
